// extracted by mini-css-extract-plugin
export var contentWrapper = "progressives-module--contentWrapper--aJ8JR";
export var header = "progressives-module--header---5uVb";
export var headerWrapper = "progressives-module--headerWrapper--YyDtv";
export var progressivesParagraph = "progressives-module--progressivesParagraph--2MXHx";
export var progressivesPhoto = "progressives-module--progressivesPhoto--l4qMz";